<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Warehouse location was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Location - {{ this.warehouseLocation.aisle }} / {{ this.warehouseLocation.shelf }}</h1>
    <app-audit-line [data]='this.warehouseLocation'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-warehouse-location-form [warehouseLocation]='this.warehouseLocation'></app-warehouse-location-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-secondary" [routerLink]='"/warehousing/locations/label/" + this.warehouseLocation.id'><i class="fas fa-print"></i> Print Label</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/locations'>Cancel</button>
    </form>
  </div>
</div>
